import React from "react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-plum-deepest text-cream/70 border-t border-gold/15">
      <div className="container-edit py-10 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <span className="font-display text-xl text-cream">
            MEL<span className="text-gold">avate</span>
          </span>
          <span className="text-[0.65rem] tracking-[0.28em] uppercase text-cream/40">
            Studios
          </span>
        </div>
        <div className="text-xs tracking-wider text-cream/50">
          &copy; {new Date().getFullYear()} Melavate Studios. Built with intention.
        </div>
        <div className="flex items-center gap-5 text-xs uppercase tracking-wider">
          <a href="#contact" className="hover:text-gold transition-colors">
            Contact
          </a>
          <a href="#services" className="hover:text-gold transition-colors">
            Services
          </a>
          <a href="#top" className="hover:text-gold transition-colors">
            Top
          </a>
        </div>
      </div>
    </footer>
  );
}
